

import Vue from 'vue'
import FastClick from 'fastclick'
import App from './App'
import router from './router'

import 'babel-polyfill'
import Es6Promise from 'es6-promise'
import ConfigPlugin from 'vux/src/plugins/config/index.js'

require('es6-promise').polyfill()
Es6Promise.polyfill()


var axios = require('axios')
axios.defaults.baseURL = 'http://test.game.justalk.com:8081/api'

Vue.prototype.$axios = axios
Vue.prototype.isDebug = true

FastClick.attach(document.body)

Vue.config.productionTip = false


Vue.use(ConfigPlugin, {
$layout: 'VIEW_BOX' 
})

/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js